// src/pages/TermsPage.jsx
// Terms of Service + Privacy Policy — satu page, dark theme

export default function TermsPage() {
  const lastUpdated = "14 June 2026";

  const sections = [
    {
      title: "1. About Promptix",
      content: `Promptix is an online SaaS platform operated by IMTECH INNOVATIONS (SSM: 202403257722 / 003652727-H) that provides AI art style prompts. Users can browse, copy, and use prompts with AI image generation tools such as Google Gemini, ChatGPT, and other compatible platforms.`,
    },
    {
      title: "2. Eligibility",
      content: `By using Promptix, you confirm that you are at least 13 years of age and have the legal capacity to enter into these Terms. If you are using Promptix on behalf of an organisation, you represent that you have the authority to bind that organisation to these Terms.`,
    },
    {
      title: "3. Account & Authentication",
      content: `Promptix uses Google Sign-In for authentication. By signing in, you agree to Google's Terms of Service and Privacy Policy. You are responsible for all activity that occurs under your account. Promptix is not liable for any loss or damage resulting from unauthorised access to your account.`,
    },
    {
      title: "4. Prompt Usage & Access Tiers",
      content: `Promptix offers the following access tiers:\n\n• Free — 3 prompts (no payment required)\n• Starter — 20 prompts, valid 30 days (RM 4.90 one-time)\n• Popular — 100 prompts, valid 30 days (RM 8.90 one-time)\n• Lifetime — Unlimited prompts, never expires (RM 9.90 one-time)\n\nAll purchases are one-time payments. There are no recurring subscriptions. Prompts from Starter and Popular tiers are non-transferable and expire after 30 days from purchase date regardless of usage.`,
    },
    {
      title: "5. Payment",
      content: `All payments are processed securely via BCL.my (Bayarcash). By completing a purchase, you agree to BCL.my's Terms of Service and Privacy Policy. Promptix does not store any payment card information.\n\nAll prices are in Malaysian Ringgit (MYR) and inclusive of applicable taxes where required.`,
    },
    {
      title: "6. Refund Policy",
      content: `Due to the digital and immediately accessible nature of our product, all sales are final and non-refundable. If you experience a technical issue that prevents access to your purchased prompts, please contact us at imtechinnovations24@gmail.com within 7 days of purchase and we will investigate and resolve the issue.`,
    },
    {
      title: "7. Intellectual Property",
      content: `All prompts, content, and materials on Promptix are the intellectual property of IMTECH INNOVATIONS unless otherwise stated. You are granted a personal, non-exclusive, non-transferable licence to use the prompts for personal or commercial creative projects.\n\nYou may not resell, redistribute, or sublicense the prompts as standalone products without written permission from IMTECH INNOVATIONS.`,
    },
    {
      title: "8. Acceptable Use",
      content: `You agree not to use Promptix to:\n\n• Generate content that is illegal, harmful, abusive, or violates the rights of others\n• Attempt to reverse engineer, scrape, or extract data from the platform\n• Share your account credentials with others\n• Circumvent any access controls or usage limits`,
    },
    {
      title: "9. Privacy Policy",
      content: `We collect the following information when you use Promptix:\n\n• Google account information (name, email, profile photo) — collected via Google Sign-In for authentication purposes\n• Usage data (number of prompts used, access tier) — stored in Firebase Firestore to manage your account\n• Language preference — stored to personalise your experience\n• Form submissions (style suggestions) — sent via Web3Forms to our email\n\nWe do not sell, share, or rent your personal data to third parties. Data is stored securely in Google Firebase infrastructure. You may request deletion of your account data by contacting us at imtechinnovations24@gmail.com.`,
    },
    {
      title: "10. Cookies",
      content: `Promptix uses Firebase Authentication which may store authentication tokens in your browser's local storage. We do not use advertising cookies or third-party tracking cookies.`,
    },
    {
      title: "11. Disclaimer of Warranties",
      content: `Promptix is provided "as is" without warranties of any kind. We do not guarantee that AI tools will produce specific results when using our prompts, as output quality depends on the AI platform used and the photo provided.`,
    },
    {
      title: "12. Limitation of Liability",
      content: `To the maximum extent permitted by Malaysian law, IMTECH INNOVATIONS shall not be liable for any indirect, incidental, or consequential damages arising from your use of Promptix. Our total liability shall not exceed the amount you paid for your current access tier.`,
    },
    {
      title: "13. Changes to Terms",
      content: `We reserve the right to update these Terms at any time. Changes will be posted on this page with an updated date. Continued use of Promptix after changes constitutes acceptance of the new Terms.`,
    },
    {
      title: "14. Governing Law",
      content: `These Terms are governed by the laws of Malaysia. Any disputes shall be subject to the exclusive jurisdiction of the courts of Malaysia.`,
    },
    {
    title: "15. Contact Us",
    content: `For any questions, concerns, or support requests, please reach out to us:\n\nEmail: imtechinnovations24@gmail.com\nBusiness: IMTECH INNOVATIONS (SSM: 202403257722 / 003652727-H)`,
    },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Space+Grotesk:wght@500;700&display=swap');
        *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
        body { background: #0c0c0f; color: #e8e8f0; font-family: 'Inter', sans-serif; min-height: 100vh; }
      `}</style>

      <div style={{ minHeight: "100vh", background: "#0c0c0f" }}>

        {/* Header */}
        <header style={{ borderBottom: "1px solid #1e1e2e", padding: "0 24px", background: "rgba(12,12,15,0.95)" }}>
          <div style={{ maxWidth: 800, margin: "0 auto", display: "flex", alignItems: "center", height: 64, gap: 12 }}>
            <a href="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none", color: "inherit" }}>
              <img src="/logo192.png" alt="Promptix" style={{ width: 36, height: 36, borderRadius: 8 }} />
              <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 17 }}>Promptix</span>
            </a>
            <span style={{ color: "#333", fontSize: 14 }}>/ Terms & Privacy</span>
          </div>
        </header>

        <div style={{ maxWidth: 800, margin: "0 auto", padding: "48px 24px 80px" }}>

          {/* Title */}
          <div style={{ marginBottom: 40 }}>
            <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 32, fontWeight: 700, marginBottom: 10 }}>
              Terms of Service & Privacy Policy
            </h1>
            <p style={{ color: "#555", fontSize: 14 }}>Last updated: {lastUpdated}</p>
            <p style={{ color: "#666", fontSize: 14, marginTop: 12, lineHeight: 1.7 }}>
              Please read these Terms carefully before using Promptix. By accessing or using our service, you agree to be bound by these Terms.
            </p>
          </div>

          {/* Sections */}
          <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
            {sections.map((section, i) => (
              <div key={i} style={{ borderTop: "1px solid #1e1e2e", paddingTop: 28 }}>
                <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 17, fontWeight: 700, marginBottom: 14, color: "#a5b4fc" }}>
                  {section.title}
                </h2>
                <p style={{ color: "#888", fontSize: 14, lineHeight: 1.9, whiteSpace: "pre-line" }}>
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div style={{ marginTop: 60, paddingTop: 24, borderTop: "1px solid #1e1e2e", textAlign: "center" }}>
            <a href="/" style={{ color: "#6366f1", fontSize: 14, textDecoration: "none", fontWeight: 600 }}>
              ← Back to Promptix
            </a>
            <p style={{ color: "#333", fontSize: 12, marginTop: 16 }}>
              IMTECH INNOVATIONS | 202403257722 (003652727-H)
            </p>
          </div>

        </div>
      </div>
    </>
  );
}